import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f9fe26e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = {
  key: 1,
  class: "center"
}
const _hoisted_3 = {
  key: 0,
  class: "ma-3 text-green-500"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_6 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_10 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_17 = { class: "d-flex flex-wrap justify-center ga-2" }
const _hoisted_18 = {
  key: 1,
  class: "pa-2 text-left"
}
const _hoisted_19 = {
  key: 0,
  class: "d-flex flex-wrap align-center justify-end ga-1 mt-1"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Válinor", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos a favor"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos en contra"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia de puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "tect-center" }, "General")
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Arda", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos a favor"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos en contra"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia de puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "tect-center" }, "General")
  ])
], -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos a favor"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos en contra"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia de puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "tect-center" }, "General")
  ])
], -1))
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1))
const _hoisted_34 = [
  _hoisted_33
]

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import { compartirTorneoCerrado } from "@/composables/useTorneoCerrado";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";
import SelectorRondas from "@/components/Commons/SelectorRondas.vue";
import { useRondasEnPestana } from "@/composables/useRondasEnPestana";
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import {
  getInfoTorneoCreadoMasAsync,
  guardarResultados,
} from "@/services/TorneosService";
import {
  GuardarResultadosDTO,
  InscripcionTorneoCreadoDTO,
  ResultadoJugador,
  TorneoGestionInfoMasDTO,
} from "@/interfaces/Torneo";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { Clasificacion, GenerarRonda } from "@/interfaces/Live";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { Torneo } from "@/interfaces/Torneo";
import {
  getPartidasTorneo,
  getTorneo,
  isSaveTournament,
} from "@/services/TorneosService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalEditarPairing from "@/components/GestionTorneos/ModalEditarPairing.vue";
import ModalEliminarPartidaTorneo from "@/components/GestionTorneos/ModalEliminarPartidaTorneo.vue";
import ModalEliminarRondaTorneo from "@/components/GestionTorneos/ModalEliminarRondaTorneo.vue";
import { appsettings } from "@/settings/appsettings";
import ModalAgregarPairing from "@/components/GestionTorneos/ModalAgregarPairing.vue";
import ModalParametrosRondasMas from "@/components/GestionTorneos/Mas/ModalParametrosRondasMas.vue";
import CardGestionTorneoMas from "@/components/GestionTorneos/Mas/CardGestionTorneoMas.vue";
import TablaInscritosMas from "@/components/GestionTorneos/Mas/TablaInscritosMas.vue";
import { getInscripcionesTorneo } from "@/services/InscripcionesService";
import {
  MatchResultGeneral,
  MatchResultPoint,
  ResultMatchMatchedPlayExtendedIndividualType,
  ResultMatchMatchedPlayType,
} from "@/Constant/TipoClasificacion";
import { calcularPuntosAleman } from "@/utils/sistemaAleman";
import { esUsuarioBye } from "@/utils/bye";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoGestionIndividualMasView',
  setup(__props) {

const isLoadingImage = ref<boolean>(false);
const torneo = ref<Torneo>();
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => torneo.value?.classificationType);
const partidas = ref<PartidaTorneoDTO[]>([]);
const numeroRondas = ref<number[]>([]);
// Al entrar, la pestaña Gestión: como en la gestión por equipos
const activeTab = ref<number>(0);
const partidasPorRonda = ref<Record<number, PartidaTorneoDTO[]>>({});
// La última ronda con partidas: la que se puede eliminar (ultimaRonda es la última del torneo, aunque no esté generada)
const ultimaRondaGenerada = computed(() =>
  Math.max(0, ...Object.keys(partidasPorRonda.value).map(Number))
);
const tabClasificacion = ref<number>();
// Para pedirle la ronda 1 y el sorteo desde los botones de la tarjeta de gestión
const tablaInscritos = ref<{ abrirGenerarRonda1: () => void; abrirSorteo: () => void }>();
const route = useRoute();
const idTorneo = ref<number>(parseInt(route.params.idTorneo.toString()));
// Hasta tener el torneo no se pinta nada: así las pestañas se montan ya con sus valores
const isLoading = ref<boolean>(true);
const torneoGestion = ref<TorneoGestionInfoMasDTO>({
  torneo: {
    idTorneo: 0,
    idUsuario: 0,
    nombreTorneo: "",
    numeroPartidas: 0,
    estadoTorneo: "",
    listasPorJugador: 0,
    mostrarListas: false,
    mostrarClasificacion: false,
  },
  inscripciones: [],
});
const clasificacion = ref<Clasificacion[]>([]);
const jugadoresZona1 = ref<Clasificacion[]>([]);
const jugadoresZona2 = ref<Clasificacion[]>([]);
const rondaAGenerar = ref<number>(0);
const showConfigModal = ref<boolean>(false);
const clasificacionDividida = ref<Clasificacion[]>([]);
const clasificacionZona1 = ref<Clasificacion[]>([]);
const clasificacionZona2 = ref<Clasificacion[]>([]);
const ultimaRonda = ref<number>();
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const isGenerating = ref<boolean>(false);
const showModificarPairingModal = ref<boolean>(false);
const showAgregarPairingModal = ref<boolean>(false);
const showEliminarPartidaModal = ref<boolean>(false);
const showEliminarRondaModal = ref<boolean>(false);
const idRondaAEliminar = ref<number>(0);
const partidaActual = ref<PartidaTorneoDTO>({
  ejercitoUsuario1: null,
  ejercitoUsuario2: null,
  escenarioPartida: null,
  fechaPartida: "",
  ganadorPartidaTorneo: null,
  idPartidaTorneo: 0,
  idTorneo: 0,
  idUsuario1: 0,
  idUsuario2: 0,
  liderMuertoUsuario1: null,
  liderMuertoUsuario2: null,
  nick1: "",
  nick2: "",
  numeroRonda: 0,
  partidaValidadaUsuario1: null,
  partidaValidadaUsuario2: null,
  resultadoUsuario1: null,
  resultadoUsuario2: null,
  idEquipo1: null,
  idEquipo2: null,
  nombreEquipo1: null,
  nombreEquipo2: null,
  idCapitan1: null,
  idCapitan2: null,
  listasJugador1: null,
  listasJugador2: null,
  numeroMesa: null,
});
const idRondaSelected = ref<number>(0);
const wasSave = ref<boolean>(false);
// Cerrado, las tarjetas y tablas no enseñan lo que ya no se puede cambiar
compartirTorneoCerrado(wasSave);
const idTorneoComputed = computed(() => idTorneo.value ?? 0);
const inscripciones = ref<InscripcionTorneoCreadoDTO[]>([]);

onMounted(async () => {
  isLoading.value = true;

  try {
    const responseTorneo = await getInfoTorneoCreadoMasAsync(idTorneo.value);
    torneoGestion.value = responseTorneo.data;
  } catch (error) {
    console.error(error);
    router.push({ name: "error" });
  }

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneo.value = responseTorneo.data;

    const responsePartidas = await getPartidasTorneo(idTorneo.value);
    partidas.value = responsePartidas.data;

    if (torneo.value) {
      numeroRondas.value = Array.from(
        { length: torneo.value.numeroPartidas },
        (_, index) => index + 1
      );
    }
    if (partidas.value) {
      partidasPorRonda.value = partidas.value.reduce(
        (acc, partida) => {
          const { numeroRonda } = partida;
          if (!acc[numeroRonda]) {
            acc[numeroRonda] = [];
          }
          acc[numeroRonda].push(partida);
          return acc;
        },
        {} as Record<number, PartidaTorneoDTO[]>
      );
    }

    tabClasificacion.value = numeroRondas.value.length + 1;

    try {
      const responseInscripciones = await getInscripcionesTorneo(
        idTorneo.value
      );
      inscripciones.value = responseInscripciones.data;
    } catch (error) {
      console.error(error);
    }

    calcularClasificacion();

    ultimaRonda.value = numeroRondas.value.length;

    const isSave = await isSaveTournament(idTorneo.value);
    wasSave.value = isSave.data;

    //const responseJugadoresInscritosTorneo = await getUsuariosByTorneo(idTorneo.value);
  } catch (error) {
    console.error("error onMounted", error);
  } finally {
    isLoading.value = false;
  }
});

const refreshTorneo = (torneoActualizado: TorneoGestionInfoMasDTO) => {
  torneoGestion.value = { ...torneoActualizado };
};

const resultados = async (ronda: number) => {
  // Con lo último que hay en la página: una partida validada después de abrirla tiene que contar
  calcularClasificacion();
  try {
    isGenerating.value = true;
    const ganadores: ResultadoJugador[] = clasificacion.value.map(
      (clasi, index) => {
        return {
          idUsuario: clasi.idUsuario,
          idTorneo: torneo.value?.idTorneo,
          resultado: index + 1,
        };
      }
    );
    const idTorneo: number | undefined = torneo.value?.idTorneo;

    if (idTorneo == undefined) return;

    const partidasUltimasRonda: GenerarRonda = {
      emparejamientos: [],
      luzVsOscCheck: false,
      mismaComunidadCheck: false,
      retosCheck: false,
      esEloCheck: false,
      opcionImpares: null,
      idTorneo: idTorneo,
      idRonda: ronda,
      isTorneoNarsil: false,
    };

    const guardarResultadosDTO: GuardarResultadosDTO = {
      ganadoresDTO: ganadores,
      generarRondaDTO: partidasUltimasRonda,
    };
    await guardarResultados(guardarResultadosDTO);
    wasSave.value = true;
    showSuccessModal.value = true;
  } catch (error) {
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }
};

const closeConfigModal = () => {
  showConfigModal.value = false;
  window.location.reload();
};

const handleConfigConfirm = () => {
  closeConfigModal();
};




const closeModificarPairingModal = () => {
  showModificarPairingModal.value = false;
};

const closeAgregarPairingModal = () => {
  showAgregarPairingModal.value = false;
};

const closeEliminarPartidaModal = () => {
  showEliminarPartidaModal.value = false;
};

const handleModificarPairingTorneoConfirm = async (
  pairingEditado: PartidaTorneoDTO
) => {
  isGenerating.value = true;
  try {
    const index = partidas.value.findIndex(
      partida => partida.idPartidaTorneo === pairingEditado.idPartidaTorneo
    );
    if (index !== -1) {
      partidas.value[index] = pairingEditado;
    }
    // El cambio puede haber pasado al jugador que sale a otra mesa: se recargan todas
    const responsePartidas = await getPartidasTorneo(idTorneo.value);
    partidas.value = responsePartidas.data;
    partidasPorRonda.value = partidas.value.reduce(
      (acc, partida) => {
        const { numeroRonda } = partida;
        if (!acc[numeroRonda]) {
          acc[numeroRonda] = [];
        }
        acc[numeroRonda].push(partida);
        return acc;
      },
      {} as Record<number, PartidaTorneoDTO[]>
    );
    // El cambio mueve la clasificación
    calcularClasificacion();
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    closeModificarPairingModal();
  }
};
const handleEliminarPartidaConfirm = (idPartidaEliminada: number) => {
  try {
    partidas.value = partidas.value.filter(
      partida => partida.idPartidaTorneo !== idPartidaEliminada
    );
    partidasPorRonda.value = partidas.value.reduce(
      (acc, partida) => {
        const { numeroRonda } = partida;
        if (!acc[numeroRonda]) {
          acc[numeroRonda] = [];
        }
        acc[numeroRonda].push(partida);
        return acc;
      },
      {} as Record<number, PartidaTorneoDTO[]>
    );
    // El cambio mueve la clasificación
    calcularClasificacion();
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    closeEliminarPartidaModal();
  }
};
// La tarjeta ya ha guardado el resultado o la validación: aquí solo se refleja. La respuesta puede venir sin nicks
const actualizarPartida = (actualizada: PartidaTorneoDTO) => {
  partidas.value = partidas.value.map(partida =>
    partida.idPartidaTorneo === actualizada.idPartidaTorneo
      ? {
          ...partida,
          ...actualizada,
          nick1: actualizada.nick1 ?? partida.nick1,
          nick2: actualizada.nick2 ?? partida.nick2,
        }
      : partida
  );
  partidasPorRonda.value = partidas.value.reduce(
    (acc, partida) => {
      const { numeroRonda } = partida;
      if (!acc[numeroRonda]) {
        acc[numeroRonda] = [];
      }
      acc[numeroRonda].push(partida);
      return acc;
    },
    {} as Record<number, PartidaTorneoDTO[]>
  );
  // El resultado mueve la clasificación
  calcularClasificacion();
};

const modificarPairing = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showModificarPairingModal.value = true;
};

const agregarPairing = (idRonda: number) => {
  idRondaSelected.value = idRonda;
  showAgregarPairingModal.value = true;
};

const eliminarPartida = (partidaRecibida: PartidaTorneoDTO) => {
  partidaActual.value = partidaRecibida;
  showEliminarPartidaModal.value = true;
};

const abrirEliminarRonda = (idRonda: number) => {
  idRondaAEliminar.value = idRonda;
  showEliminarRondaModal.value = true;
};

const closeEliminarRondaModal = () => {
  showEliminarRondaModal.value = false;
};

const handleEliminarRondaConfirm = (mensaje: string) => {
  partidas.value = partidas.value.filter(
    p => p.numeroRonda !== idRondaAEliminar.value
  );
  delete partidasPorRonda.value[idRondaAEliminar.value];
  showSuccessModal.value = true;
  console.info(mensaje);
};

const handleEliminarRondaError = (mensaje: string) => {
  showErrorModal.value = true;
  console.error(mensaje);
};

const generarSiguienteRonda = (ronda: number) => {
  try {
    rondaAGenerar.value = ronda;
    showConfigModal.value = true;
  } catch (error) {
    console.error("Error al generar la siguiente ronda:", error);
  }
};

const calcularClasificacion = () => {
  const ranking: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
    }
  > = {};
  const rankingDividido: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
    }
  > = {};

  // Filtramos hasta la ronda 2 para dividir el grupo
  const partidasFiltradas = partidas.value?.filter(
    partida => partida.numeroRonda <= 2
  );

  partidasFiltradas?.forEach(partida => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!rankingDividido[partida.idUsuario1]) {
        rankingDividido[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }
      if (!rankingDividido[partida.idUsuario2]) {
        rankingDividido[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }

      // Actualizamos puntos a favor y en contra
      rankingDividido[partida.idUsuario1].puntosFavor += puntosUsuario1;
      rankingDividido[partida.idUsuario1].puntosContra += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosFavor += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      rankingDividido[partida.idUsuario1].diferenciaPuntos =
        rankingDividido[partida.idUsuario1].puntosFavor -
        rankingDividido[partida.idUsuario1].puntosContra;
      rankingDividido[partida.idUsuario2].diferenciaPuntos =
        rankingDividido[partida.idUsuario2].puntosFavor -
        rankingDividido[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (torneo.value?.classificationType === 1) {
        //CLASIFICACION TIPO NORMAL
        if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          rankingDividido[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          rankingDividido[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
      } else if (torneo.value?.classificationType === 2) {
        //CLASIFICACION TIPO EXTENDED
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 === res2) {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayExtendedIndividualType.DRAW;
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayExtendedIndividualType.DRAW;
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        } else {
          if (res1 > res2) {
            if (res1 >= 2 * res2 && res1 >= 6) {
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_WIN;
              rankingDividido[partida.idUsuario1].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario2].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_LOSS;
            } else {
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_WIN;
              rankingDividido[partida.idUsuario1].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario2].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_LOSS;
            }
          }
          if (res2 > res1) {
            if (res2 >= 2 * res1 && res2 >= 6) {
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_WIN;
              rankingDividido[partida.idUsuario2].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario1].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_LOSS;
            } else {
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_WIN;
              rankingDividido[partida.idUsuario2].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario1].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_LOSS;
            }
          }
        }
      } else if (torneo.value?.classificationType === 3) {
        //CLASIFICACION TIPO ALEMAN
        // Sistema alemán: la suma de puntos de ambos jugadores es 20
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 > res2) {
          rankingDividido[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (res2 > res1) {
          rankingDividido[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
        const { jugador1, jugador2 } = calcularPuntosAleman(res1, res2);
        rankingDividido[partida.idUsuario1].puntosTorneo += jugador1;
        rankingDividido[partida.idUsuario2].puntosTorneo += jugador2;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        rankingDividido[partida.idUsuario1].lider += MatchResultGeneral.DEAD;
      }
      if (liderMuertoUsuario2) {
        rankingDividido[partida.idUsuario2].lider += MatchResultGeneral.DEAD;
      }
    }
  });

  clasificacionDividida.value = Object.values(rankingDividido).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  dividirClasificacionEnZonas();

  // Clasificacion normal
  partidas.value?.forEach(partida => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!ranking[partida.idUsuario1]) {
        ranking[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }
      if (!ranking[partida.idUsuario2]) {
        ranking[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }

      // Actualizamos puntos a favor y en contra
      ranking[partida.idUsuario1].puntosFavor += puntosUsuario1;
      ranking[partida.idUsuario1].puntosContra += puntosUsuario2;
      ranking[partida.idUsuario2].puntosFavor += puntosUsuario2;
      ranking[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      ranking[partida.idUsuario1].diferenciaPuntos =
        ranking[partida.idUsuario1].puntosFavor -
        ranking[partida.idUsuario1].puntosContra;
      ranking[partida.idUsuario2].diferenciaPuntos =
        ranking[partida.idUsuario2].puntosFavor -
        ranking[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (torneo.value?.classificationType === 1) {
        //CLASIFICACION TIPO NORMAL
        if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
      } else if (torneo.value?.classificationType === 2) {
        //CLASIFICACION TIPO EXTENDED
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 === res2) {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayExtendedIndividualType.DRAW;
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayExtendedIndividualType.DRAW;
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        } else {
          if (res1 > res2) {
            if (res1 >= 2 * res2 && res1 >= 6) {
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_WIN;
              ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_LOSS;
            } else {
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_WIN;
              ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_LOSS;
            }
          }
          if (res2 > res1) {
            if (res2 >= 2 * res1 && res2 >= 6) {
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_WIN;
              ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MAJOR_LOSS;
            } else {
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_WIN;
              ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedIndividualType.MINOR_LOSS;
            }
          }
        }
      } else if (torneo.value?.classificationType === 3) {
        //CLASIFICACION TIPO ALEMAN
        // Sistema alemán: la suma de puntos de ambos jugadores es 20
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 > res2) {
          ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (res2 > res1) {
          ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
        const { jugador1, jugador2 } = calcularPuntosAleman(res1, res2);
        ranking[partida.idUsuario1].puntosTorneo += jugador1;
        ranking[partida.idUsuario2].puntosTorneo += jugador2;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        ranking[partida.idUsuario1].lider += MatchResultGeneral.DEAD;
      }
      if (liderMuertoUsuario2) {
        ranking[partida.idUsuario2].lider += MatchResultGeneral.DEAD;
      }
    }
  });

  inscripciones.value.forEach(inscripcion => {
    const userId = inscripcion.idUsuario;
    if (ranking[userId]) {
      ranking[userId].puntosTorneo += inscripcion.puntosExtra;
    }
  });

  // El bye no es un jugador: ni sale en la clasificación ni se guarda como posición
  clasificacion.value = Object.values(ranking).filter(j => !esUsuarioBye(j.idUsuario, j.nick)).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  // Clasificacion por zonas
  clasificacionZona1.value = clasificacion.value.filter(jugador =>
    jugadoresZona1.value.some(z => z.idUsuario === jugador.idUsuario)
  );

  clasificacionZona2.value = clasificacion.value.filter(jugador =>
    jugadoresZona2.value.some(z => z.idUsuario === jugador.idUsuario)
  );

  type JugadorConEjercito = {
    nick: string;
    ejercito: string | null;
  };

  const jugadoresConEjercitos = partidas.value.reduce<JugadorConEjercito[]>(
    (acc, partida) => {
      // Solo las que tienen ejército: en la primera ronda puede faltar si aún no había entregado la lista
      if (partida.ejercitoUsuario1)
        acc.push({ nick: partida.nick1, ejercito: partida.ejercitoUsuario1 });
      if (partida.ejercitoUsuario2)
        acc.push({ nick: partida.nick2, ejercito: partida.ejercitoUsuario2 });
      return acc;
    },
    []
  );

  const listaEjercitos = appsettings.armies;

  const ejercitosJugadoresConBando = jugadoresConEjercitos.map(jugador => {
    const ejercito = listaEjercitos.find(e => e.name === jugador.ejercito);
    return {
      nick: jugador.nick,
      ejercito: jugador.ejercito,
      bando: ejercito ? ejercito.band : "desconocido",
    };
  });

  clasificacion.value = clasificacion.value.map(j => {
    const bando = ejercitosJugadoresConBando.find(
      e => e.nick === j.nick
    )?.bando;
    return { ...j, bando }; // Devuelve el objeto original más el atributo bando
  });
};

const dividirClasificacionEnZonas = () => {
  const totalJugadores = clasificacionDividida.value.length;
  const esImpar = totalJugadores % 2 !== 0;

  const mitad = Math.floor(totalJugadores / 2);
  let zona1Size = esImpar ? mitad + 1 : mitad;
  if (zona1Size % 2 !== 0) zona1Size = zona1Size + 1;

  jugadoresZona1.value = clasificacionDividida.value.slice(0, zona1Size);
  jugadoresZona2.value = clasificacionDividida.value.slice(zona1Size);
};

const isRondaValidada = (numeroRonda: number) => {
  if (!partidasPorRonda.value[numeroRonda]) {
    return false;
  }

  return partidasPorRonda.value[numeroRonda].every(
    partida =>
      partida.partidaValidadaUsuario1 === true &&
      partida.partidaValidadaUsuario2 === true
  );
};

// Los puntos extra que cambia el organizador mueven la clasificación al momento, sin recargar
const actualizarPuntosExtra = (idUsuario: number, puntosExtra: number) => {
  const inscripcion = inscripciones.value.find(i => i.idUsuario === idUsuario);
  if (inscripcion) inscripcion.puntosExtra = puntosExtra;
  calcularClasificacion();
};

const handleInscripcionEliminada = (idInscripcion: number) => {
  if (torneoGestion.value) {
    // Actualiza las inscripciones eliminando la inscripción correspondiente
    torneoGestion.value.inscripciones =
      torneoGestion.value.inscripciones.filter(
        inscripcion => inscripcion.idInscripcion !== idInscripcion
      );
  }
};



// const abrirModalPuntos = (idPartida: number, usuario: 1 | 2) => {
//   idPartidaSeleccionada.value = idPartida;
//   usuarioSeleccionado.value = usuario;
//   isModalPuntosVisible.value = true;
// };

// const abrirModalLider = (idPartida: number, usuario: 1 | 2) => {
//   idPartidaSeleccionada.value = idPartida;
//   usuarioSeleccionado.value = usuario;
//   isModalLiderVisible.value = true;
// };

// const abrirModalEscenario = (idPartida: number) => {
//   idPartidaSeleccionada.value = idPartida;
//   isModalEscenarioVisible.value = true;
// };











// Las rondas en una sola pestaña: activeTab sigue siendo el número de ronda
const {
  pestana,
  enRondas,
  TAB_RONDAS,
  jugadorBuscado,
  jugadores,
  deLaBusqueda,
  mesaDe,
} = useRondasEnPestana(
  activeTab,
  numeroRondas,
  partidasPorRonda
);

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(LoadingGandalf)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_card, {
                      class: "mx-auto",
                      "max-width": "800"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tabs, {
                          modelValue: _unref(pestana),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pestana) ? (pestana).value = $event : null)),
                          grow: "",
                          "center-active": "",
                          "fixed-tabs": ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_tab, {
                              key: 0,
                              text: `Gestión`,
                              value: 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Gestión")
                              ]),
                              _: 1
                            })),
                            _createVNode(_component_v_tab, {
                              value: _unref(TAB_RONDAS),
                              text: "Rondas"
                            }, null, 8, ["value"]),
                            (_openBlock(), _createBlock(_component_v_tab, {
                              key: tabClasificacion.value,
                              text: `Clasificación`,
                              value: tabClasificacion.value
                            }, null, 8, ["value"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_unref(enRondas))
                          ? (_openBlock(), _createBlock(SelectorRondas, {
                              key: 0,
                              modelValue: activeTab.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
                              rondas: numeroRondas.value,
                              partidasPorRonda: partidasPorRonda.value,
                              jugador: _unref(jugadorBuscado),
                              "onUpdate:jugador": _cache[2] || (_cache[2] = ($event: any) => (_isRef(jugadorBuscado) ? (jugadorBuscado).value = $event : null)),
                              jugadores: _unref(jugadores)
                            }, null, 8, ["modelValue", "rondas", "partidasPorRonda", "jugador", "jugadores"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_tabs_window, {
                          modelValue: _unref(pestana),
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(pestana) ? (pestana).value = $event : null))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                              value: 0,
                              key: 0
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(CardGestionTorneoMas, { torneo: torneoGestion.value }, {
                                    acciones: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "tonal",
                                            color: "primary",
                                            block: "",
                                            disabled: partidasPorRonda.value[1] !== undefined,
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (tablaInscritos.value?.abrirGenerarRonda1()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Generar ronda 1 ")
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "tonal",
                                            color: "primary",
                                            block: "",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (tablaInscritos.value?.abrirSorteo()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Sorteo ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["torneo"]),
                                  _createVNode(TablaInscritosMas, {
                                    ref_key: "tablaInscritos",
                                    ref: tablaInscritos,
                                    torneo: torneoGestion.value,
                                    onInscripcionEliminada: handleInscripcionEliminada,
                                    onCambios: refreshTorneo,
                                    onPuntosExtra: actualizarPuntosExtra
                                  }, null, 8, ["torneo"])
                                ])
                              ]),
                              _: 1
                            })),
                            (isRondaValidada(activeTab.value))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createTextVNode(" Todas las partidas están validadas "),
                                  (!wasSave.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(_component_v_list_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_content, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_5, [
                                                      _createVNode(_component_v_btn, {
                                                        class: "mt-2",
                                                        variant: "tonal",
                                                        color: "secondary",
                                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (agregarPairing(activeTab.value)))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Añadir partida ")
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (ultimaRonda.value != activeTab.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        (partidasPorRonda.value[activeTab.value + 1] != undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " La ronda " + _toDisplayString(activeTab.value + 1) + " ya se ha generado ", 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_content, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_9, [
                                                            _createVNode(_component_v_btn, {
                                                              class: "mt-2",
                                                              variant: "tonal",
                                                              color: "primary",
                                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (generarSiguienteRonda(activeTab.value + 1)))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(" Generar siguiente ronda ")
                                                              ]),
                                                              _: 1
                                                            }),
                                                            (activeTab.value === ultimaRondaGenerada.value && !wasSave.value)
                                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 0,
                                                                  class: "mt-2",
                                                                  variant: "tonal",
                                                                  color: "error",
                                                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (abrirEliminarRonda(activeTab.value)))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(" Eliminar ronda ")
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        (wasSave.value)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Resultados guardados: el torneo está cerrado."))
                                          : _createCommentVNode("", true),
                                        (!wasSave.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              class: "mt-2",
                                              variant: "tonal",
                                              color: "primary",
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (resultados(activeTab.value)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Guardar resultados ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (!wasSave.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              class: "mt-2 ml-2",
                                              variant: "tonal",
                                              color: "error",
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (abrirEliminarRonda(activeTab.value)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Eliminar ronda ")
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])),
                                  (
                    !partidasPorRonda.value[activeTab.value] &&
                    activeTab.value != 0 &&
                    activeTab.value != numeroRondas.value.length + 1
                  )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createTextVNode(" Esperando ronda... "),
                                        (!wasSave.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _createVNode(_component_v_list_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_content, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_14, [
                                                            _createVNode(_component_v_btn, {
                                                              class: "mt-2",
                                                              variant: "tonal",
                                                              color: "secondary",
                                                              onClick: _cache[10] || (_cache[10] = ($event: any) => (agregarPairing(activeTab.value)))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(" Añadir partida ")
                                                              ]),
                                                              _: 1
                                                            })
                                                          ])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        (partidasPorRonda.value[activeTab.value])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                              _createTextVNode(" Faltan partidas por validar "),
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_v_list_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_17, [
                                                              (!wasSave.value)
                                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                    key: 0,
                                                                    class: "mt-2",
                                                                    variant: "tonal",
                                                                    color: "secondary",
                                                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (agregarPairing(activeTab.value)))
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(" Añadir partida ")
                                                                    ]),
                                                                    _: 1
                                                                  }))
                                                                : _createCommentVNode("", true),
                                                              (activeTab.value === ultimaRondaGenerada.value && !wasSave.value)
                                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                    key: 1,
                                                                    class: "mt-2",
                                                                    variant: "tonal",
                                                                    color: "error",
                                                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (abrirEliminarRonda(activeTab.value)))
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(" Eliminar ronda ")
                                                                    ]),
                                                                    _: 1
                                                                  }))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : _createCommentVNode("", true),
                            (partidasPorRonda.value[activeTab.value!]?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deLaBusqueda)(partidasPorRonda.value[activeTab.value!]), (partida) => {
                                    return (_openBlock(), _createBlock(CardPartidaGestion, {
                                      key: partida.idPartidaTorneo,
                                      partida: partida,
                                      editable: true,
                                      etiqueta: `Mesa ${_unref(mesaDe)(partidasPorRonda.value[activeTab.value!], partida)}`,
                                      onPartidaActualizada: actualizarPartida
                                    }, {
                                      default: _withCtx(() => [
                                        (!wasSave.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                              _createVNode(_component_v_btn, {
                                                size: "small",
                                                variant: "text",
                                                "prepend-icon": "mdi-swap-horizontal",
                                                onClick: ($event: any) => (modificarPairing(partida))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Cambiar emparejamiento ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_v_btn, {
                                                size: "small",
                                                variant: "text",
                                                color: "error",
                                                icon: "mdi-delete",
                                                "aria-label": "Eliminar partida",
                                                title: "Eliminar partida",
                                                onClick: ($event: any) => (eliminarPartida(partida))
                                              }, null, 8, ["onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["partida", "etiqueta"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                              value: tabClasificacion.value,
                              key: tabClasificacion.value
                            }, {
                              default: _withCtx(() => [
                                (torneo.value?.idTorneo === 7)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      (
                      clasificacionZona1.value.length > 0 &&
                      clasificacionZona2.value.length > 0
                    )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _hoisted_22,
                                            (activeTab.value == tabClasificacion.value)
                                              ? (_openBlock(), _createBlock(_component_v_table, {
                                                  key: 0,
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_23,
                                                    _createElementVNode("tbody", null, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacionZona1.value, (jugador, index) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                          key: jugador.nick
                                                        }, [
                                                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.nick), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
                                                        ]))
                                                      }), 128))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_divider, { class: "my-5" }),
                                            _hoisted_24,
                                            (activeTab.value == tabClasificacion.value)
                                              ? (_openBlock(), _createBlock(_component_v_table, {
                                                  key: 1,
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_25,
                                                    _createElementVNode("tbody", null, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacionZona2.value, (jugador, index) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                          key: jugador.nick
                                                        }, [
                                                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.nick), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
                                                        ]))
                                                      }), 128))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      (clasificacion.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            (activeTab.value == tabClasificacion.value)
                                              ? (_openBlock(), _createBlock(_component_v_table, {
                                                  key: 0,
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_31,
                                                    _createElementVNode("tbody", null, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacion.value, (jugador, index) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                          key: jugador.nick,
                                                          class: _normalizeClass({
                            'good-bando': jugador.bando === 'good',
                            'evil-bando': jugador.bando === 'evil',
                          })
                                                        }, [
                                                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.nick), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                                                          _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
                                                        ], 2))
                                                      }), 128))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                                    ]))
                              ]),
                              _: 1
                            }, 8, ["value"])),
                            _createVNode(_component_v_tabs_window_item, { value: _unref(TAB_RONDAS) }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: isLoadingImage.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isLoadingImage).value = $event)),
        persistent: "",
        width: "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "d-flex justify-center align-center",
                style: {"height":"150px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "blue-lighten-3",
                    size: 57
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ModalParametrosRondasMas, {
        isVisible: showConfigModal.value,
        torneo: torneoGestion.value,
        clasificacion: clasificacion.value,
        clasificacionDividida: clasificacionDividida.value,
        ronda: rondaAGenerar.value,
        onClose: closeConfigModal,
        onConfirm: handleConfigConfirm
      }, null, 8, ["isVisible", "torneo", "clasificacion", "clasificacionDividida", "ronda"]),
      _createVNode(ModalEditarPairing, {
        isVisible: showModificarPairingModal.value,
        partida: partidaActual.value,
        idTorneo: idTorneoComputed.value,
        onCerrar: closeModificarPairingModal,
        onConfirm: handleModificarPairingTorneoConfirm
      }, null, 8, ["isVisible", "partida", "idTorneo"]),
      _createVNode(ModalAgregarPairing, {
        isVisible: showAgregarPairingModal.value,
        idTorneo: idTorneo.value,
        idRonda: idRondaSelected.value,
        onCerrar: closeAgregarPairingModal
      }, null, 8, ["isVisible", "idTorneo", "idRonda"]),
      _createVNode(ModalEliminarPartidaTorneo, {
        isVisible: showEliminarPartidaModal.value,
        partida: partidaActual.value,
        onCerrar: closeEliminarPartidaModal,
        onConfirm: handleEliminarPartidaConfirm
      }, null, 8, ["isVisible", "partida"]),
      _createVNode(ModalEliminarRondaTorneo, {
        isVisible: showEliminarRondaModal.value,
        idTorneo: idTorneo.value,
        idRonda: idRondaAEliminar.value,
        onCerrar: closeEliminarRondaModal,
        onConfirm: handleEliminarRondaConfirm,
        onError: handleEliminarRondaError
      }, null, 8, ["isVisible", "idTorneo", "idRonda"]),
      _createVNode(ModalSuccess, {
        isVisible: showSuccessModal.value,
        message: "Acción realizada correctamente.",
        "onUpdate:isVisible": _cache[15] || (_cache[15] = ($event: any) => (showSuccessModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalError, {
        isVisible: showErrorModal.value,
        message: "No se han podido guardar los resultados. Intentalo de nuevo y si el error persiste contacta con el administrador.",
        "onUpdate:isVisible": _cache[16] || (_cache[16] = ($event: any) => (showErrorModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(_component_v_dialog, {
        modelValue: isGenerating.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((isGenerating).value = $event)),
        "hide-overlay": "",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "progress-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "70"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})